<template>
  <VideoNavigationEditor
    class="video-navigation-editor"
    ref="videoNavigationEditorRef"
    appendToBody
    :rootCompanyId="forms.rootCompanyId"
    :languageCode="forms.language"
    :data="forms.videoNavigationList"
  ></VideoNavigationEditor>
</template>

<script>
import { mapActions } from 'vuex'
import Optional from 'optional-js'
import editorTemplate from '../editorTemplate'
import VideoNavigationEditor from '@/components/job/editor/videoNavigationEditor.vue'

export default {
  mixins: [editorTemplate],
  components: {
    VideoNavigationEditor
  },
  data () {
    return {
      forms: {
        rootCompanyId: null,
        language: null,
        videoNavigationList: []
      }
    }
  },
  computed: {

  },
  created () {
    const props = this.renderData.data.props
    this.forms.rootCompanyId = props.rootCompanyId
    this.forms.language = props.language
    this.forms.videoNavigationList = props.videoNavigationList
  },
  mounted () {
    this._getCompanyTree()
  },
  methods: {
    ...mapActions('microSite', [
      'getCompanyTree'
    ]),
    async _getCompanyTree () {
      this.companies = Optional.ofNullable(await this.getCompanyTree()).map(item => item).orElse({})
      this.forms.rootCompanyId = this.companies[2].companyId
    },
    async validateAndUpdateRenderData () {
      this.validateError = false
      const resp = await this.$refs.videoNavigationEditorRef.submit()
      if (resp) {
        this.forms.language = resp.language_code
        this.forms.videoNavigationList = resp.video_list
      } else {
        return false
      }

      const props = this.renderData.data.props
      props.rootCompanyId = this.forms.rootCompanyId
      props.language = this.forms.language
      props.videoNavigationList = this.forms.videoNavigationList
      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
